import React, {Component} from 'react';

//Components
import NavBar from '../../../_components/common/Navbar';
import Footer from '../../../_components/common/Footer';
import SettingsHead from '../../../_components/common/SettingsHead';
import CustomTableNew from '../../../_components/common/CustomTableNew';
import ModalNew2 from '../../../_components/common/ModalNew2';
import {CommonBreadCrumb} from '../../../_components/common/CommonBreadCrumb';
import {LoaderComp} from '../../../_components/common/LoaderComp/Loadercomp';

//redux
import {connect} from 'react-redux';


//actions
import {worksheetAction} from '../../../_actions/WorkSheet/workSheet.action';


//table data
import table from './tableData';

//css
import './worksheet.css';


class Worksheet extends Component {
    state = {
        workSheetData: [],
        workSheetSharedData: [],
        assessmentId: 0,
        currentInstrumentId: 0,
        addModal: false,
        editModal: false,
        worksheetId: 0,
        editData: [{
            key: 'worksheet_name',
            type: 'text',
            value: '',
            valid: false,
            elementConfig: {
                name: 'worksheet_name',
                label: 'My Worksheet Name',
                options: []
            },
            validation: {
                required: true,
                message: "is required"
            } 
        }],
        workSheetData: table.worksheet,
        sharedWithTableData: table.worksheetShared,
        addData: [{
            key: 'expiry_list',
            type: 'disabledText',
            value: 'Apr-2018',
            valid: true,
            elementConfig: {
                name: 'expiry',
                label: 'Assessment',
                options: []
            },
            validation: {
                required: false,
                message: "is required"
            } 
        },{
            key: 'orientation__orientation_name',
            type: 'select',
            value: '',
            valid: false,
            elementConfig: {
                name: 'orientation__orientation_name',
                label: 'Template',
                options: [],
                id: 'orientation_id',
                storeKey: ['worksheetOrientationReducerSingle', 'orientationData']
            },
            validation: {
                required: true,
                message: "is required"
            } 
        },
        {
            key: 'worksheet_name',
            type: 'text',
            value: '',
            valid: false,
            elementConfig: {
                name: 'worksheet_name',
                label: 'My Worksheet Name',
                options: []
            },
            validation: {
                required: true,
                message: "is required"
            } 
        }],
        filterColumn: table.worksheet,
        orientationApi_data: []
    }

    componentDidMount() {

        //add modal opener to table column data
        table.worksheet.map(val => {
            if (val.modalData !== undefined) {
                val.modalData.map(value => {
                    value.modalOpenerFunc = (data) => this.modalOpener(data)
                })
            }
        })

        let assessmentIdFromPath = this.props.location.pathname.match(/\d/g);
        assessmentIdFromPath = assessmentIdFromPath.join("");

        let currentInstrumentId = parseInt(localStorage.getItem('currentInstrumentId'))
        let assessmentCreationDate = new Date(localStorage.getItem('assessmentCreationDate'))


        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        let month = assessmentCreationDate.getUTCMonth();
        let year = assessmentCreationDate.getUTCFullYear();

        let newdate = monthNames[month] + "-" + year;
       

        let addData = [...this.state.addData]
        addData.map(val => {
            if(val.key === 'expiry_list') {
                val.value = newdate
            }
        })

        let filterColumn = []

        table.worksheet.map(val => {
            if(val.name !== '') {
                filterColumn.push(val)
            }
        })

        this.setState({
            addData,
            currentInstrumentId,
            filterColumn,
            assessmentId: parseInt(assessmentIdFromPath, 10)
        }, () => {
            
            let workSheetData = [...this.state.workSheetData];

            workSheetData.map(val => {
                if(val.key === 'worksheet_name') {
                    val.link = `/app/dashboard/${this.state.assessmentId}/workSheet/`
                }
            })

            let sharedWithTableData = [...this.state.sharedWithTableData]

            sharedWithTableData.map(val => {
                if(val.key === 'worksheet__worksheet_name') {
                    val.link = `/app/dashboard/${this.state.assessmentId}/workSheet/`
                }
            })

            this.setState({
                workSheetData,
                sharedWithTableData
            })

            const {dispatch} = this.props;
            dispatch(worksheetAction.getWorksheetHandler(this.state.assessmentId))
            dispatch(worksheetAction.orientationApi({
                instrument_id: this.state.currentInstrumentId
            },this.state.assessmentId, (orientationApi_data) => {
                if(orientationApi_data.data.response.length === 1) {

                    addData.map(val => {
                        if(val.key === 'orientation__orientation_name') {
                            val.type = 'disabledText'
                            val.value = orientationApi_data.data.response[0].orientation__orientation_name
                            val.valid = true
                        }
                    })
                    this.setState({
                        addData,
                        orientationApi_data: orientationApi_data.data.response
                    })
                }
            }))
        })

    }

    componentDidUpdate(prevProps) {
        if(prevProps.workSheetData !== this.props.workSheetData) {
            let workSheetData = [...this.props.workSheetData]
            workSheetData.map(val => {
                let dateObj = new Date(val.assessment__created);
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

                let month = dateObj.getUTCMonth();
                let year = dateObj.getUTCFullYear();

                let newdate = monthNames[month] + "-" + year;
                val.assessment__created = newdate;
            })
            this.setState({
                workSheetData
            })
           
        }
        if(prevProps.workSheetSharedData !== this.props.workSheetSharedData) {
            let workSheetSharedData = [...this.props.workSheetSharedData]
            workSheetSharedData.map(val => {
                let dateObj = new Date(val.worksheet__assessment__created);
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

                let month = dateObj.getUTCMonth();
                let year = dateObj.getUTCFullYear();

                let newdate = monthNames[month] + "-" + year;
                val.worksheet__assessment__created = newdate;
            })
            this.setState({
                workSheetSharedData
            })
        }
    }

    //filter func
    filterData(data) {
       
        this.setState({
            workSheetData: data
        })
    }

    filterDataSharedData(data) {
        this.setState({
            workSheetSharedData: data
        })
    }
    
    //add modal functions
    addModalToggler(data) {
      
        let currentInstrumentId = parseInt(localStorage.getItem('currentInstrumentId'))
        let assessmentCreationDate = new Date(localStorage.getItem('assessmentCreationDate'))


        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        let month = assessmentCreationDate.getUTCMonth();
        let year = assessmentCreationDate.getUTCFullYear();

        let newdate = monthNames[month] + "-" + year;
      

        let addData = [...this.state.addData]
        addData.map(val => {
            if(val.key === 'expiry_list') {
                val.value = newdate
            }
            if(val.key === 'orientation__orientation_name' && this.state.orientationApi_data.length === 1) {
                val.type = 'disabledText'
                val.value = this.state.orientationApi_data[0].orientation__orientation_name
                val.valid = true
            }
        })
        this.setState({
            addData,
            addModal: true
        })
    }
    addAction(data) {
     

        let dataObj = {}

        if(this.state.orientationApi_data.length === 1) {
            dataObj = {
                assessment: this.state.assessmentId,
                orientation: this.state.orientationApi_data[0].orientation_id,
                worksheet_name: data.worksheet_name
            }
        }else {
            dataObj = {
                assessment: this.state.assessmentId,
                orientation: data.orientation__orientation_name,
                worksheet_name: data.worksheet_name
            }
        }

        let currentInstrumentId = parseInt(localStorage.getItem('currentInstrumentId'))
        let assessmentCreationDate = new Date(localStorage.getItem('assessmentCreationDate'))


        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        let month = assessmentCreationDate.getUTCMonth();
        let year = assessmentCreationDate.getUTCFullYear();

        let newdate = monthNames[month] + "-" + year;
     

        let addData = [...this.state.addData]
        addData.map(val => {
            if(val.type === 'disabledText') {
                val.value = newdate
            }
        })

        const { dispatch } = this.props;
        dispatch(worksheetAction.createWorksheet(dataObj))
        this.setState({
            addData
        })
    }
    toggleAdd(data) {

        this.setState({
            addModal: false
        })
    }
    
    
    
    
    //edit modal functions
    editAction(data) {
  
        const {dispatch} = this.props;
        dispatch(worksheetAction.updateWorksheetHandler({
            assessmentId: this.state.assessmentId,            
            data,
            id: this.state.worksheetId
        }))
    }
    toggleEdit(data) {
     
        this.setState({
            editModal: false
        })
    }
    modalOpener(data) {
      
        let editData = [...this.state.editData] 
        editData.map(val => {
            if(val.key === 'worksheet_name') {
                val.value = data.rowData.worksheet_name
            }
        })
        this.setState({
            editData,
            worksheetId: data.rowData.id,
            editModal: !this.state.editModal,
        })
    }


    render() {
        const {workSheetListError, getWorksheetLoading, getSharedUsersLoading, workSheetSharedError} = this.props;
       
        return (
            <div className="worksheet">
                <NavBar />
                <div className="container mb-4">
                    <CommonBreadCrumb 
                        data={[
                            {
                                link: '/app/dashBoard',
                                name: 'DASHBOARD'
                            },{
                                link: '',
                                name: 'GOAL-SETTING WORKSHEETS'
                            }
                        ]}
                    />
                    <div style={{height: 40}} className="bg-green rounded-top animation-fade-in">
                        {
                            <div className="d-flex justify-content-between align-items-center">
                                <p></p>
                                <p className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">MY WORKSHEETS</p>
                                {
                                    (!workSheetListError && !getWorksheetLoading) ?
                                    <p></p>
                                    :
                                    <LoaderComp color={'white'} />
                                }                   
                            </div>
                        }
                    </div>
                    {
                        (!workSheetListError && !getWorksheetLoading) &&
                            <SettingsHead 
                                buttonData = {[{
                                    id: 1,
                                    heading: "CREATE NEW WORKSHEET",
                                    state: this.state.addModal,
                                    toggler: this.addModalToggler.bind(this),
                                }]}
                                columns = { this.state.filterColumn }
                                view={ this.filterData.bind(this) }
                                sellers = { this.props.workSheetData }
                                showModal={ false }
                                filter="true"
                                widthClass = { 'col-md-6' }
                            />
                    }
                    <CustomTableNew
                        data={this.state.workSheetData}
                        columns={table.worksheet}
                        showSlNo="false"
                        modalOpener = {this.modalOpener.bind(this)}
                    />
                    
                </div>
                <Footer />
                        {
                            this.state.addModal &&
                                <ModalNew2
                                    heading="ADD WORKSHEET"
                                    showModal={this.state.addModal}
                                    formData={this.state.addData}
                                    action={this.addAction.bind(this)}
                                    toggleModal={this.toggleAdd.bind(this)}
                                    viewMessage={[{ text: '' }]}
                                    triggerType={"SUBMIT"}
                                />
                        }
                        {
                            this.state.editModal &&
                                <ModalNew2
                                    heading="UPDATE WORKSHEET NAME"
                                    showModal={this.state.editModal}
                                    formData={this.state.editData}
                                    action={this.editAction.bind(this)}
                                    toggleModal={this.toggleEdit.bind(this)}
                                    viewMessage={[{ text: '' }]}
                                    triggerType={"SUBMIT"}
                                />
                        }
            </div>
        )
    }
}

const MapStateToProps = state => {
    const workSheetListError = state.getWorksheetReducer.error;
    const {getWorksheetLoading} = state.getWorksheetReducer;
    const workSheetData = (!workSheetListError && !getWorksheetLoading) ? state.getWorksheetReducer.data.data.worksheet_list : []


    const workSheetSharedError = state.getSharedUsersReducer.error;
    const {getSharedUsersLoading} = state.getSharedUsersReducer;
    const workSheetSharedData = (!workSheetSharedError && !getSharedUsersLoading) ? state.getSharedUsersReducer.data.data.response : []

    return {
        workSheetData,
        workSheetListError,
        getWorksheetLoading,
        workSheetSharedData,
        getSharedUsersLoading,
        workSheetSharedError
    }
}

export default connect(MapStateToProps)(Worksheet)


// WEBPACK FOOTER //
// ./src/_pages/DashBoard/worksheet/worksheet.js